import Environment from './environment';

const debug = Environment.isDev();

export const log = function (msg, title = '') {
  if (debug) {
    console.log(msg, title);
  }
};

export const todo = function (msg) {
  if (debug) {
    console.log(`%c todo: ${msg}`, 'background: #2684FF; color: #fff; padding-right: 10px;');
  }
};

export const warn = function (msg) {
  if (debug) {
    console.warn(msg);
  }
};

export const error = function (msg, title = '') {
  if (debug) {
    console.error(msg, title);
  } else {
    // @todo: track error somewhere
  }
};

